import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Typography } from "@circle-react-shared/uikit/Typography";
import type { useGetThemeStats } from "../../useGetThemeStats";

interface ThemeUsageStatsProps {
  themeStats: NonNullable<ReturnType<typeof useGetThemeStats>["data"]>;
}

export const ThemeUsageStats = ({ themeStats }: ThemeUsageStatsProps) => {
  const hasPageUsage = themeStats.page_theme_usage_count > 0;
  const hasSiteUsage = themeStats.site_theme_usage_count > 0;

  return (
    <Typography.BodyMd color="text-dark">
      {t(
        "builder_ui.theme_configuration.delete_custom_theme_modal.description.theme_in_use_places",
        {
          count: themeStats.total_count,
        },
      )}
      <ul className="list-inside list-disc pl-2">
        {hasPageUsage && (
          <li>
            {t(
              "builder_ui.theme_configuration.delete_custom_theme_modal.description.theme_in_page_use",
              {
                count: themeStats.page_theme_usage_count,
              },
            )}{" "}
            {themeStats.page_theme_usage.length > 0 && (
              <TippyV2
                content={
                  <div className="space-y-1">
                    {themeStats.page_theme_usage.map(page => (
                      <Link
                        key={page.id}
                        to={`/settings/pages/edit/${page.id}`}
                        className="text-link block"
                      >
                        {page.name}
                      </Link>
                    ))}
                  </div>
                }
              >
                <span className="text-link cursor-pointer">
                  {t(
                    "builder_ui.theme_configuration.delete_custom_theme_modal.description.view_page",
                    {
                      count: themeStats.page_theme_usage_count,
                    },
                  )}
                </span>
              </TippyV2>
            )}
          </li>
        )}
        {hasSiteUsage && (
          <li>
            {hasPageUsage
              ? t(
                  "builder_ui.theme_configuration.delete_custom_theme_modal.description.theme_in_site_use_with_page_themes",
                  {
                    count: themeStats.site_theme_usage_count,
                  },
                )
              : t(
                  "builder_ui.theme_configuration.delete_custom_theme_modal.description.theme_in_site_use_only",
                  {
                    count: themeStats.site_theme_usage_count,
                  },
                )}
          </li>
        )}
      </ul>
    </Typography.BodyMd>
  );
};
